import { render, staticRenderFns } from "./platformDetail.vue?vue&type=template&id=6d026eeb&scoped=true&"
import script from "./platformDetail.vue?vue&type=script&lang=ts&"
export * from "./platformDetail.vue?vue&type=script&lang=ts&"
import style0 from "./platformDetail.vue?vue&type=style&index=0&id=6d026eeb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d026eeb",
  null
  
)

export default component.exports